export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_12.4f475ef1.jpg";